export const CartUpdateActionType = {
  ADD: "ADD",
  REMOVE: "REMOVE",
  CLEAR: "CLEAR",
  INCREMENT: "INC",
  DECREMENT: "DEC",
  CUSTOM_QUANTITY: "CUSTOM_QTY",
};
